import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';
import QRCode from 'qrcode.react';

import { CustomCard } from "../../../components/Card/CustomCard";
import CustomModal from "../../../components/Modal/CustomModal";

import { ConsultaDeudaEst, PagarInd } from "../../../funciones/EstCuentaFunction";
import { ConsultCitadosReinsc, ConsultAllCitadosReinsc, ConsultDetallesReinsc, NoInscribir, InscribirAdmin,
        BusquedaEstReins, CambiaFechaAdm } from "../../../funciones/AdmisionFunction";
import { ConsultVerificacionesInd, ConsultMetodos, ConsultCambio } from '../../../funciones/AdministracionFunction';
import { ConsultCuentaAdminHist } from "../../../funciones/EstCuentaFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import VerificacionPagoTable from "../../Administracion/EstadosCuentaContent/VerificacionPagoTable";

import ModalReports from '../../../components/Reportes/ModalReports';
import ReinscripcionCitados from '../../../components/Reportes/ReinscripcionCitados';

import CambiaFecha from '../../AdmisionAdmin/AdmisionAdminContent/CambiaFecha';

let IdUser = "";
let idDetalle = "";
let CuentaPay = 0;
let errores = 0;
let fecha = new Date();

class Reinscripcion extends Component {
    state = {   
        cantCitados: 0,
        preloader: "fa fa-spinner fa-spin",
        citados: [],
        string:{
            text: "Selecciona un estudiante citado para revisar",
            icon: ""
        },
        strings: "",
        icon2: "",
        textCitados: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando estudiantes citados"
        },
        textCitadosHoy: "Estudiantes Citados para Hoy",
        disabled: false,
        datosDetalle: "",
        carrera: "",
        materias: true,
        iconChevron1: "fa fa-chevron-up",
        btnDown1: false,
        estados: true,
        estadosHist: false,
        iconChevron2: "fa fa-chevron-up",
        btnDown2: false,
        iconChevron3: "fa fa-chevron-down",
        btnDown3: true,

        openNoAccept: false,
        openAccept: false,
        openPago: false,

        materiasInscritas:[],
        preloadInsc: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando materias inscritas"
        },
        valorUc: "",
        asientos: [],
        asientosHist: [],
        verificaciones: [],
        metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
        metodos: [],
        deudaT: "",
        fecha: fecha,
        otroMonto: "",
        total: true,
        otro: false,
        concepto: "",
        cambio: "",
        divisas: "",
        bsCambio: 0,
        selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
        cuentas: [],
        num: "",
        factura: "",
        boton1:{
            text: "Aprobar",
            icon: "fa fa-check"
        },
        boton2:{
            text: "No Aprobar",
            icon: "fa fa-times"
        },
        boton4:{
            text: "Registrar Pago",
            icon: "fa fa-money"
        },
        modalPagoBtn1: {
            icon:"fa fa-money",
            text: "Registrar",
            disabled: false
        },
        modalNoAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        modalAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        motivo : {
            text:"",
            mensaje: ""
        },
        openWR: false,
        btnFull: { icon: "fa fa-plus", text: "Ver Todo", disabled: false },
        openCFecha: false,
        fechaO: "",
        modalFechaBtn1: {
            icon:"fa fa-calendar-plus-o",
            text: "Cambiar",
            disabled: false
        },
    }

    componentDidMount = () => {
        ConsultCitadosReinsc ((resp) => {
            if (resp.length === 0) {
                this.setState({
                    textCitados: {
                        icon: "",
                        text: "No tienes estudiantes citados para el dia de hoy"
                    },
                    citados: resp,
                    cantCitados: resp.length,
                    preloader: ""
                })
            }else{
                this.setState({
                    citados: resp,
                    cantCitados: resp.length,
                    preloader: ""
                })
            }
        })

        ConsultMetodos ((resp) => {
            this.setState({
                metodos: resp
            })
        })

        ConsultCambio ((resp) => {
            this.setState({
                cambio: resp
            })
        })
    }

    busquedaEst = () => (e) => {
        idDetalle = "";
        if (e.which === 13){
            this.setState ({
                icon2: "fa fa-spinner fa-spin",
                textCitados: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando estudiantes"
                },
                citados: [],
                cantCitados: 0,
            }, () => {
                BusquedaEstReins (this.state.strings, (resp) => {
                    if (resp.length === 0) {
                        this.setState({
                            icon2: "",
                            textCitados: {
                                icon: "",
                                text: "No tienes estudiantes que coincidan con la búsqueda"
                            },
                            textCitadosHoy: "Coincidencias",
                            citados: resp,
                            cantCitados: resp.length,
                            preloader: ""
                        })
                    }else{
                        this.setState({
                            icon2: "",
                            citados: resp,
                            cantCitados: resp.length,
                            preloader: ""
                        })
                    }
                })
            })
        }
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase(),
        });
    };

    cambiaValor2 = (prop) => (event) => {
        this.setState({
            [prop]: {
                text: (event.target.value).toUpperCase(),
                mensaje: ""
            }
        });
    };

    verTodo = () => (e) => {
        if (this.state.btnFull.disabled === true) return null
        this.setState({
            btnFull: {icon: "fa fa-spinner fa-spin", text: "Buscando", disabled: true},
            textCitados: { icon: "fa fa-spinner fa-spin", text: "Buscando Estudiantes" }
        }, () => {
            ConsultAllCitadosReinsc ((resp) => {
                if (resp.length === 0) {
                    this.setState({
                        textCitados: {
                            icon: "",
                            text: "No tienes estudiantes citados"
                        },
                        textCitadosHoy: "Todos los Estudiantes",
                        citados: resp,
                        cantCitados: resp.length,
                        preloader: "",
                        btnFull: {icon: "fa fa-plus", text: "Ver Todo", disabled: false}
                    })
                }else{
                    this.setState({
                        citados: resp,
                        cantCitados: resp.length,
                        preloader: "",
                        btnFull: {icon: "fa fa-plus", text: "Ver Todo", disabled: false},
                        textCitadosHoy: "Todos los Estudiantes",
                    })
                }
            })
        })
    }

    revisar = (est) => {
        idDetalle = "";
        IdUser = est;
        this.setState({
            string: {
                text: "Buscando los detalles de la reinscripción",
                icon: "fa fa-spinner fa-spin"
            },
            disabled: false
        }, () => {
            ConsultDetallesReinsc (est, (resp)=> {

                CuentaPay = resp[4]
                idDetalle = est;
                this.setState({
                    string: {
                        text: "",
                        icon: ""
                    },
                    datosDetalle: resp[0],
                    carrera: resp[1],
                    materiasInscritas: resp[2],
                    valorUc: resp[3]
                })
            })

            ConsultVerificacionesInd (IdUser, (resp)=> {
                this.setState({verificaciones: resp,})
            })

            ConsultaDeudaEst (IdUser, (resp) => {
                errores = resp.errores;
                this.setState({deudaT: resp})
            })

            ConsultCuentaAdminHist (IdUser, (resp)=> {
                this.setState({
                    asientos: resp[0],
                    asientosHist: resp[1]
                })
            })
        })
    }

    nombre = (nom1, nom2, ape1, ape2) => {
        if (nom2 === null) nom2 = "";
        if (ape2 === null) ape2 = "";
        return `${nom1} ${nom2} ${ape1} ${ape2}`
    }

    lisCitados = () => {
        let { textCitados, citados, disabled } = this.state;

        if (citados.length === 0) return (
            <tr>
                <td colSpan={4} align="center"><i className={textCitados.icon}></i> {textCitados.text}</td>
            </tr>
        )

        const styles = { padding: 5, fontSize: 12 }
        return (
            citados.map (option => (
                <tr key = {option.id_est}>
                    <td style={styles}>{`${option.nacionalidad} ${option.ci}`}</td>
                    <td style={styles}>{this.nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)}</td>
                    <td align="center" style={styles}>{option.carrera_name}</td>
                    <td align="center" style={styles}>
                        <button disabled={disabled} onClick={() => { this.revisar(option.id_est) }} className="btn btn-primary" style={{borderWidth: 1}} title="Revisar los detalles de la inscripción"><i className="fa fa-check"></i> Revisar</button>
                    </td>
                </tr>
            ))
        )
    }

    nombre = (nom1, nom2, ape1, ape2) => {
        if (nom2 === null) nom2 = "";
        if (ape2 === null) ape2 = "";
        return `${nom1} ${nom2} ${ape1} ${ape2}`
    }

    contenidoInt = () => {
        if (idDetalle === "") return null;
        let { datosDetalle, carrera, materias, iconChevron1, materiasInscritas, preloadInsc, valorUc,
            estados, iconChevron2, asientos, verificaciones, boton1, boton2, boton4, asientosHist, iconChevron3,
            estadosHist } = this.state;

        const styles = { padding: 5, fontSize: 12 }
        const stylesBs = { padding: 3, fontSize: 10 }

        let materiasInsc = () => {
            if (materiasInscritas.length === 0) return (
                <tr>
                    <td colSpan={6} align="center"><i className={preloadInsc.icon}></i> {preloadInsc.text}</td>
                </tr>
            )

            return (
                materiasInscritas.map (option => (
                    <tr key = {option.id}>
                        <td style={styles}>{option.materia_name}</td>
                        <td style={styles} align="center">{option.nombre}</td>
                        <td style={styles} align="center">{option.tipoev_name}</td>
                        <td style={styles} align="center">{option.semestre_name}</td>
                        <td style={styles} align="center">{option.u_c}</td>
                        <td style={stylesBs} align="center">
                            {formatNumber((option.u_c * valorUc))}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.u_c * valorUc)}</div> */}
                        </td>
                    </tr>
                ))
            )
        }

        let contentEstado = () => {
            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                asientos.map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                        <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                        <td align="center" style={stylesBs}>
                            {formatNumber(option.saldo)}
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                        </td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let pagos = () => (
            verificaciones.map(option => (
                <VerificacionPagoTable key={option.id} datos={option} updList = {() => {
                    ConsultVerificacionesInd (IdUser, (resp)=> {
                        this.setState({verificaciones: resp,})
                    })
                    ConsultCuentaAdminHist (IdUser, (resp)=> {
                        this.setState({
                            asientos: resp[0],
                            asientosHist: resp[1]
                        })
                    })
                    ConsultaDeudaEst (IdUser, (resp) => {
                        errores = resp.errores;
                        this.setState({deudaT: resp})
                    })
                }}/>
            ))
        )

        let pays = () => {
            if (CuentaPay === 0) return null;

            return(
                <div className="custom-alert-info custom-mt-10" style={{padding: 2}}>
                    <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "30vh", overflowX:"hidden"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="60%%" style={styles}><strong>Detalles del Pago</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {pagos()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )
        }
 
        let EstadoCuenta = () => (
            <React.Fragment>
                <div className="table-responsive" style={{overflowY: "auto", maxHeight:"30vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="10%" align="center"style={styles}><strong>N°</strong></td>
                                <td width="10%" align="center"style={styles}><strong>Fecha</strong></td>
                                <td width="40%" style={styles}><strong>Descripción</strong></td>
                                <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                <td width="30px" align="center" style={styles}></td>
                            </tr>
                            {contentEstado()}
                        </tbody>
                    </Table>
                </div>
                {pays()}
            </React.Fragment>
        )

        let contentEstadoHist = () => {
            if (asientosHist.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos históricos disponibles</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            let num = 0
            return (
                asientosHist.map(option => {
                    num++;
                    return(
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                            <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                            <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                            <td align="center" style={stylesBs}>
                                {formatNumber(option.saldo)}
                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                            </td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    )
                })
            )
        }
        
        let histAsientos = () => {
            if (asientosHist.length === 0) return null;

            return(
                <PanelGroup accordion activeKey={estadosHist} className="custom-alert-danger">
                    <Panel eventKey = {true}>
                        <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown3", "iconChevron3", "estadosHist")}}>
                            <Panel.Title toggle className="text-danger">
                                <Row>
                                    <Col md={10} style={{fontSize: 12}}>
                                        <strong><i className="fa fa-calendar"></i> Histórico de Asientos</strong>
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron3}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingTop:10}}>
                            <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                                <Table striped hover bordered style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                            <td width="40%" style={styles}><strong>Descripción</strong></td>
                                            <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                            <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                            <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                            <td width="30px" align="center" style={styles}></td>
                                        </tr>
                                        {contentEstadoHist()}
                                    </tbody>
                                </Table>
                            </div>
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
            )
        }

        let cambiaCita = () => {
            return (
                <div className="custom-alert-danger">
                    <Row>
                        <Col md={9} style={{paddingTop: 5}}><strong>Fecha de la cita: </strong>{datosDetalle.fecha_cita}</Col>
                        <Col md={3} align = "right">
                            <button className="btn btn-relleno-danger btn-sm" onClick = {() => {this.setState({openCFecha:true})}} style={{borderWidth: 1}}><i className="fa fa-calendar"></i> Cambiar</button>
                        </Col>
                    </Row>
                </div>
            )
        }

        return (
            <Row>
                <Col md={12}>
                    <div className="custom-alert-info">
                        Detalles de la Solicitud
                    </div>
                </Col>
                <Col md={12} className="custom-mt-10" style={{paddingTop: 3}}>
                    <div><strong>Carrera: </strong>{carrera}</div>
                    <div><strong>Fecha de la solicitud: </strong>{datosDetalle.fecha_solicitud}</div>
                    <div><strong>Cédula de Identidad: </strong>{`${datosDetalle.nacionalidad} ${datosDetalle.ci}`}</div>
                    <div><strong>Nombres y Apellidos: </strong>{this.nombre(datosDetalle.nombre_1, datosDetalle.nombre_2, datosDetalle.apellido_1, datosDetalle.apellido_2)}</div>
                </Col>
                <Col md={12} className="custom-mt-10">
                    {cambiaCita()}
                </Col>
                <Col md={12} className="custom-mt-10">
                    <PanelGroup accordion activeKey={materias} className="custom-alert-info">
                        <Panel eventKey = {true}>
                            <Panel.Heading  onClick = {()=> {this.cambiaIcon( "btnDown1", "iconChevron1", "materias")}}>
                                <Panel.Title toggle className="custom-color">
                                    <Row>
                                        <Col md={10} style={{fontSize: 12}}>
                                            Materias Inscritas
                                        </Col>
                                        <Col md={2} align="right">
                                            <i className={iconChevron1}></i>
                                        </Col>
                                    </Row>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                                    <Table striped hover bordered>
                                        <tbody>
                                            <tr className="custon-back-color">
                                                <td align="center" width="35%" style={styles}><strong>Materia</strong></td>
                                                <td width="10%" style={styles}><strong>Sección</strong></td>
                                                <td align="center" width="15%" style={styles}><strong>Modalidad</strong></td>
                                                <td align="center" width="15%" style={styles}><strong>Semestre</strong></td>
                                                <td align="center" width="10%" style={styles}><strong>U.C.</strong></td>
                                                <td align="center" width="15%" style={stylesBs}><strong>Monto Bs.</strong></td>
                                            </tr>
                                            {materiasInsc()}
                                        </tbody>
                                    </Table>
                                </div>
                            </Panel.Body>
                        </Panel>
                    </PanelGroup>
                </Col>
                <Col md={12}>
                    {histAsientos()}
                </Col>
                <Col md={12}>
                    <PanelGroup accordion activeKey={estados} className="custom-alert-info">
                        <Panel eventKey = {true}>
                            <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown2", "iconChevron2", "estados")}}>
                                <Panel.Title toggle className="custom-color">
                                    <Row>
                                        <Col md={10} style={{fontSize: 12}}>
                                            Estado de Cuenta
                                        </Col>
                                        <Col md={2} align="right">
                                            <i className={iconChevron2}></i>
                                        </Col>
                                    </Row>
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                {EstadoCuenta()}
                            </Panel.Body>
                        </Panel>
                    </PanelGroup>
                </Col>
                <Col md = {12} className="custom-mt-10" align="right">
                    <div className="btn-group" style={{marginRight: 5}}>
                        <button className="btn btn-warning" onClick = {
                            () => {
                                this.setState({
                                    openPago: true,
                                    otroMonto: "",
                                    total: true,
                                    otro: false,
                                    concepto: "",
                                    divisas: "",
                                    selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                                    metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                                    num: "",
                                    modalPagoBtn1: {
                                        icon:"fa fa-money",
                                        text: "Registrar"
                                    },
                                    total: true,
                                    bsCambio: 0,
                                    factura: ""
                                })
                            }} 
                        title="Registrar pago" style={{borderWidth: 1}}><i className={boton4.icon}></i> {boton4.text}</button>
                    </div>
                    <div className="btn-group">
                        <button className="btn btn-primary" onClick = {() => {this.setState({openAccept: true})}} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                        <button className="btn btn-danger" onClick = {() => {this.setState({openNoAccept: true})}} style={{borderWidth: 1}}><i className={boton2.icon}></i> {boton2.text}</button>
                    </div>
                </Col>
            </Row>
        )
    }

    contenido = () => {
        let { cantCitados, preloader, string, strings, icon2, btnFull, textCitadosHoy } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info" style={{padding: 5}}>
                    <Row>
                        <Col md={6}>
                            <div style={{marginTop: 10}}><i className="fa fa-clone"></i> {textCitadosHoy} <strong>({cantCitados})</strong><i className={preloader}></i></div>
                        </Col>
                        <Col md={6} align="right">
                            <div className="btn-group">
                                <button className="btn btn-relleno-primary" onClick={() => {this.setState({openWR: true})}} title= "Imprimir listado de estudiantes citados" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                                <button className="btn btn-relleno-danger" onClick = {this.verTodo()} style={{borderWidth: 1}} title = "Ver todos los aspirantes"><i className={btnFull.icon}></i> {btnFull.text}</button>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="custom-alert-info custom-mt-10">
                    Búsqueda de Estudiantes <i className={icon2}></i>
                    <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={strings} onChange={this.cambiaValor("strings")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div>

                <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                    <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color-warning">
                                    <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                    <td width="50%" style={styles}><strong>Aspirante</strong></td>
                                    <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {this.lisCitados()}
                            </tbody>
                        </Table>
                    </div>
                </div>
                
                <div className="custom-mt-10">
                    <div className="text-danger" align="center"><i className={string.icon}></i> {string.text}</div>
                    {this.contenidoInt()}
                </div>
            </React.Fragment>
        )
    }

    modalNoAccept = () => {
        const { openNoAccept, modalNoAcceptBtn1, motivo } = this.state;

        let noAceptar = (id) => (e) => {
            if (this.state.modalNoAcceptBtn1.disabled === true) return null;

            if ((motivo.text) === "") {
                this.setState({
                    motivo : {
                        text:"",
                        mensaje: "Indica primero el motivo",
                    }
                })
                return null;
            }

            this.setState({
                modalNoAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            NoInscribir  (id, motivo.text, (resp) => {
                this.setState ({
                    openNoAccept: false,
                    motivo : {
                        text:"",
                        mensaje: ""
                    }
                },() => {
                    idDetalle = "";
                    toast.info("Has eliminado correctamente la reinscripción del estudiante",{autoClose: 4000});
                    ConsultCitadosReinsc ((resp) => {
                        if (resp.length === 0) {
                            this.setState({
                                textCitados: {
                                    icon: "",
                                    text: "No tienes estudiantes citados para el dia de hoy"
                                },
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalNoAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                            })
                        }else{
                            this.setState({
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalNoAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                            })
                        }
                    })
                })
            })
        }

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-danger"> NO APROBAR</strong> la reinscripción de este Estudiante?</div>
                
                <div className="custom-alert-danger" style={{padding:5}}>
                    <input type="text" value={motivo.text} onChange={this.cambiaValor2("motivo")} className="form-control" placeholder="Indica el motivo"/>
                    <span className="text-danger" style={{fontSize: 12}}>{motivo.mensaje}</span>
                </div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalNoAcceptBtn1.icon}></i> {modalNoAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNoAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(IdUser)}
                funcion2 = {() => {this.setState({openNoAccept: false})}}
            />
        );
    }

    modalAccept = () => {
        const { openAccept, modalAcceptBtn1 } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-primary">APROBAR</strong> la reinscripción de este Estudiante?</div>
                <div style={{fontSize: 12, padding: 5}} className="custom-alert-danger" align="center"><i className="fa fa-exclamation-triangle"></i> <strong>Recuerda revisar primero el pago de los aranceles antes de aceptar</strong></div>
            </React.Fragment>
        )

        let Aceptar = (id) => (e) => {
            if (this.state.modalAcceptBtn1.disabled === true) return null;

            this.setState({
                modalAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })
            
            InscribirAdmin (id,  () => {
                this.setState ({
                    openAccept: false,
                    motivo : {
                        text:"",
                        mensaje: ""
                    },
                },() => {
                    idDetalle = "";
                    toast.info("Has aceptado correctamente la reinscripción del estudiante",{autoClose: 4000});
                    ConsultCitadosReinsc ((resp) => {
                        if (resp.length === 0) {
                            this.setState({
                                textCitados: {
                                    icon: "",
                                    text: "No tienes estudiantes citados para el dia de hoy"
                                },
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                }
                            })
                        }else{
                            this.setState({
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                }
                            })
                        }
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalAcceptBtn1.icon}></i> {modalAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(IdUser)}
                funcion2 = {() => {this.setState({openAccept: false})}}
            />
        );
    }

    modalFecha = () => {
        let {openCFecha, modalFechaBtn1, datosDetalle, fechaO} = this.state;

        if (datosDetalle === "") return null;

        let contenidoModal = () => (
            <CambiaFecha fechaI = {datosDetalle.fecha_cita} fechaO= {(date) => {this.setState({fechaO: date})}}
                         clear = {() => {this.setState({fechaO: ""})}}/>
        )

        let cambiar = () => {
            if (modalFechaBtn1.disabled === true || IdUser === "") return null;

            if (fechaO === ""){
                toast.error("Debes seleccionar una fecha",{autoClose: 4000});
                return null;
            }


            this.setState({
                modalFechaBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                CambiaFechaAdm(IdUser, fechaO, (resp) => {
                    toast[resp.status](resp.mess,{autoClose: 4000});
                    idDetalle = "";
                    IdUser = "";
                    this.setState({
                        openCFecha: false,
                        modalFechaBtn1: {
                            icon:"fa fa-calendar-plus-o",
                            text: "Cambiar",
                            disabled: false
                        },
                        fechaO: ""
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalFechaBtn1.icon}></i> {modalFechaBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openCFecha}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Cambiar fecha de Reinscripción</div>}
                contenido = {contenidoModal()}      
                funcion1 = {cambiar}
                funcion2 = {() => {this.setState({openCFecha: false})}}
            />
        )
    }

    valorMetodo = (metodoSelect) => {
        this.setState({
            metodoSelect
        });
    }

    cambiaValorM = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    cambiaValorDivisa = () => (event) => {
        if (!isNaN(Number(event.target.value)) === false) return null;
        let valorCambio = parseInt(this.state.cambio) * parseInt(event.target.value)
        if (event.target.value === "") valorCambio = 0;
        this.setState({
            divisas: event.target.value,
            openNoAccept: false,
            openAccept: false,
            bsCambio: valorCambio
        });
    };

    pagar = (prop) => {
        this.setState({
            total: false,
            otro: false,
        }, () => { 
            this.setState({[prop]: true})
        })
    }

    modalReporte = () => {
        let { openWR, citados } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<ReinscripcionCitados datos = {citados} />}
                titulo={`Listado de Estudiantes Citados`}
                display= "block"
                cerrar = {() => {this.setState({openWR: false})}}
            />
        )
    }

    modalPago = () => {
        const { openPago, modalPagoBtn1, metodoSelect, metodos, total, otro, otroMonto, deudaT, concepto, fecha,
            cambio, divisas, bsCambio, selectcuenta, cuentas, num, factura, observaciones } = this.state;

        let campos = {metodoSelect, divisas, bsCambio, num, fecha, deudaT, otroMonto, total, otro, concepto, selectcuenta,
            observaciones, factura};

        const styles = {
            padding: 2, fontSize: 12
        }

        let pagar = () => {
            if (this.state.modalPagoBtn1.disabled === true) return null

            if (metodoSelect.value === "") {
                toast.error("Debes elegir un método de pago",{autoClose: 4000});
                return null;
            }

            this.setState({
                modalPagoBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {
                PagarInd (IdUser, "Reinscripcion", campos, this.state.deudaT.deudaVencida,(resp) => {
                    if (resp[0] === "Error"){
                        this.setState({
                            modalPagoBtn1: {
                                icon:"fa fa-check",
                                text:"Registrar",
                                disabled: false
                            }  
                        })
                    }else{
                        if (resp[3] === true) idDetalle = "";

                        this.setState({
                            openPago: false,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            divisas: "",
                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                            num: ""
                        }, () => {
                            ConsultCitadosReinsc ((resp) => {
                                if (resp.length === 0) {
                                    this.setState({
                                        textCitados: {
                                            icon: "",
                                            text: "No tienes estudiantes citados para el dia de hoy"
                                        },
                                        citados: resp,
                                        cantCitados: resp.length,
                                        preloader: ""
                                    })
                                }else{
                                    this.setState({
                                        citados: resp,
                                        cantCitados: resp.length,
                                        preloader: ""
                                    })
                                }
                            })

                            ConsultaDeudaEst (IdUser, (resp) => {
                                errores = resp.errores;
                                this.setState({deudaT: resp})
                            })
                            ConsultVerificacionesInd (IdUser, (resp)=> {
                                this.setState({verificaciones: resp,})
                            })
                            ConsultCuentaAdminHist (IdUser, (resp)=> {
                                this.setState({
                                    asientos: resp[0],
                                    asientosHist: resp[1]
                                })
                            })
                        });
                    }
                    toast[resp[2]](resp[1],{autoClose: 4000});
                })
            })
        }

        let montoPayEf = () => (
            <div className="table-responsive">
                <Table bordered style={{marginBottom: 0}}>
                    <tbody>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                            </td>
                        </tr>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )

        let montoDivisa = () => (
            <React.Fragment>
                <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                <Row>
                    <Col md={5}>
                        <input type="text" maxLength= {4} onChange ={this.cambiaValorDivisa()} value={divisas} className="form-control" placeholder="Ej.: 50"/>
                        <div className="text-muted" style={{fontSize: 9}}>Monto en Divisas ($)</div>  
                    </Col>
                    <Col md={7}>
                        <input type="text" maxLength= {50} disabled value={bsCambio} className="form-control"/>
                        <div className="text-muted" style={{fontSize: 9}}>Equivalencia en Bs.</div>
                    </Col>
                </Row>
                <div className="text-danger" style={{fontSize: 10, marginTop: 5}}>Cambio del dia: <strong>{cambio} Bs por Dólar</strong></div>
            </React.Fragment>
        )

        let conceptoEf = () => (
            <React.Fragment>
                <Col md={12}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
            </React.Fragment>
        )

        let contenidoGral = () => (
            <React.Fragment>
                <Col md={6} className="custom-mt-10">
                    <input maxLength= {20} type="text" value={num} onChange={this.cambiaValorM("num")} className="form-control" placeholder="Ej.: 001828212828"/>
                    <div className="text-muted" style={{fontSize: 9}}>(*) N° de Referencia</div>
                </Col>
                <Col md={6} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
                <Col md={6} className="custom-mt-10 text-danger">(*) Monto:</Col>
                <Col md={6} className="custom-mt-10 text-danger">Concepto:</Col>
                <Col md={6}>
                    <div className="table-responsive">
                        <Table bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col md={6}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} rows={5} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
            </React.Fragment>
        )

        let contentPay = () => {
            switch (metodoSelect.label) {
                case "EFECTIVO":
                    return(
                        <Row>
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoPayEf()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "DIVISA":
                    return(
                        <Row> 
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoDivisa()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "TRANSFERENCIA":
                    return(
                        <Row>
                            <Col md={12}>
                                <Select
                                    isSearchable ={true}
                                    value={selectcuenta}
                                    onChange={this.valorCuenta}
                                    options={cuentas}
                                />
                                <div className="text-muted" style={{fontSize: 9}}>(*) Seleccciona el número de cuenta al cual hiciste la transferencia</div>
                            </Col>
                            {contenidoGral()}
                        </Row>
                    )
                case "DEBITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                case "CREDITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                default: return (
                    <div className="text-danger" align="center">Selecciona un Método de Pago</div>
                )
            }
        }

        let contenidoModal = () => (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <Select
                            isSearchable ={true}
                            value={metodoSelect}
                            onChange={this.valorMetodo}
                            options={metodos}
                        />
                        <div className="text-muted" style={{fontSize: 9}}>Selecciona un Método de Pago</div>
                    </Col>
                    <Col md={6}>
                        <input type="text" value={factura} onChange={this.cambiaValorM("factura")} className="form-control" placeholder="N° de Factura"/>
                        <div className="text-danger" style={{fontSize: 9}}>Número de la Factura</div>
                    </Col>
                </Row>
                <div className="custom-mt-10">{contentPay()}</div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalPagoBtn1.icon}></i> {modalPagoBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openPago}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Registrar Pago de Aranceles</div>}
                contenido = {contenidoModal()}      
                funcion1 = {pagar}
                funcion2 = {() => {this.setState({openPago: false})}}
            />
        );
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En este módulo verás una lista de estudiantes a un cupo que han completado correctamente la reinscripción y están citados para el dia de hoy
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
            </Col>
            <Col md={12} align="justify">
                Selecciona un estudiante de la lista y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-check"></i> Revisar</button>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
            </Col>
            <Col md={12} align="justify">
                Luego de presionar el el botón podrás ver los detalles de la solicitud, los datos personales, las materias inscritas y el estado de cuenta.
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Una vez revisado la solicitud tienes dos opciones disponibles:
            </Col>
            <Col md={4} className="custom-mt-10" align="center">
                <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-check"></i> Aceptar</button>
            </Col>
            <Col md={8} className="custom-mt-10" align="justify">
                Permite Aceptar la inscripción del estudiante (Esa opción libera el estudiante para que <strong>Control de Estudios</strong> pueda aprobar la inscripción)
            </Col>
            <Col md={4} className="custom-mt-10" align="center">
                <button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-times"></i> No Aceptar</button>
            </Col>
            <Col md={8} className="custom-mt-10" align="justify">
                Esta opción elimina la solicitud de inscripción del estudiante y le envía un correo de notificación
            </Col>
            <Col md={4} className="custom-mt-10" align="center">
                <button className="btn btn-warning btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Registrar Pago</button>
            </Col>
            <Col md={8} className="custom-mt-10" align="justify">
                Esta opción permite agregar el pago en cualquier modalidad <strong className="text-primary">(Nota: Es importante revisar el pago de los aranceles antes de aceptar la reinscripción)</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong>Nota: Todas las solicitudes que no lleguen al momento de la cita serán rechazadas automáticamente</strong>
            </Col>
        </Row>
    )

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Reinscripciones</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalNoAccept()}
                {this.modalFecha()}
                {this.modalAccept()}
                {this.modalPago()}
                {this.modalReporte()}
            </div>
        );
    }
}
 
export default Reinscripcion;


// WEBPACK FOOTER //
// ./src/views/Administracion/ReinscripcionesContent/Reinscripcion.jsx